// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__3TOu1","title":"ClientInsurance_title__3Z-es","itemText":"ClientInsurance_itemText__3XxWF"};